import { isPureArray } from '@asset-metrix/portal-ui';

import { FilterSlice } from '../store/states/filter';
import { FilterConfigDto } from '../store/states/filterTypes';

type ParsedFilterValue = string[] | boolean[] | null;

/**
 * Trys to coerce values from URL to supported datatypes for filters
 */
const parseFilterValue = (filters: string[] | null): ParsedFilterValue => {
  if (!Array.isArray(filters)) {
    return filters;
  }

  const parsedFilters = filters.map((f) => {
    if (f === 'true') {
      return true;
    }

    if (f === 'false') {
      return false;
    }

    return f;
  });

  if (isPureArray(parsedFilters)) {
    return parsedFilters;
  }

  return filters;
};

export const presetFilterSelectionForFilter = (
  presetFilterSelection: FilterSlice['presetFilterSelection'],
  instanceId: string,
  filterValueFromUrl: string[] | null,
  filterConfig: FilterConfigDto
) => {
  const value = parseFilterValue(filterValueFromUrl);
  if (value != null && value.length > 0) {
    if (filterConfig.display === 'multi-select') {
      presetFilterSelection(
        instanceId,
        filterConfig.key,
        filterConfig.display,
        filterConfig.type,
        value
      );
    } else if (
      ['single-select', 'search', 'single-date-picker'].includes(
        filterConfig.display
      )
    ) {
      presetFilterSelection(
        instanceId,
        filterConfig.key,
        filterConfig.display,
        filterConfig.type,
        value[0]
      );
    } else if (filterConfig.display === 'range-date-picker') {
      try {
        const rangeObj: { gte: string; lte: string } = JSON.parse(
          String(value[0])
        );
        if (rangeObj.gte != null || rangeObj.lte != null) {
          presetFilterSelection(
            instanceId,
            filterConfig.key,
            filterConfig.display,
            filterConfig.type,
            {
              ...(rangeObj.lte != null ? { end: rangeObj.lte } : {}),
              ...(rangeObj.gte != null ? { start: rangeObj.gte } : {}),
            }
          );
        }
      } catch {
        throw new Error(
          `Parsing search params for key "${filterConfig.key}" failed`
        );
      }
    } else if (filterConfig.display === 'range-number-picker') {
      try {
        const rangeObj: { gte: string; lte: string } = JSON.parse(
          String(value[0])
        );
        if (rangeObj.gte != null || rangeObj.lte != null) {
          presetFilterSelection(
            instanceId,
            filterConfig.key,
            filterConfig.display,
            filterConfig.type,
            {
              ...(rangeObj.lte != null
                ? { end: Number.parseFloat(rangeObj.lte) }
                : {}),
              ...(rangeObj.gte != null
                ? { start: Number.parseFloat(rangeObj.gte) }
                : {}),
            }
          );
        }
      } catch {
        throw new Error(
          `Parsing search params for key "${filterConfig.key}" failed`
        );
      }
    }
  }
};
